var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 8,
  r: 8,
  fill: "#D20071"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.3916 16.7031C24.9723 18.5453 29 23.8021 29 30H1C1 23.8024 5.02719 18.5455 10.6074 16.7031C11.9278 17.3709 13.4192 17.75 15 17.75C16.5805 17.75 18.0714 17.3706 19.3916 16.7031Z",
  fill: "#D20071"
})));
export default SvgUser;